import axios from 'axios';
import apiClient from '../../../core/api/client';

const publicClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
});

export const createShareLink = (receiptId) =>
  apiClient.post(`/api/receipts/${receiptId}/share`);

export const revokeShareLink = (receiptId) =>
  apiClient.delete(`/api/receipts/${receiptId}/share`);

export const getShareStatus = (receiptId) =>
  apiClient.get(`/api/receipts/${receiptId}/share`);

export const getSharedReceipt = (shareToken) =>
  publicClient.get(`/api/shared/${shareToken}`);

export const getSharedReceiptImageUrl = (shareToken) =>
  `${publicClient.defaults.baseURL}/api/shared/${shareToken}/image`;
